import React, { useState, useEffect, useContext } from 'react';
import {Grid, GridColumn as Column, GridDataStateChangeEvent, GridSortChangeEvent, GridCustomCellProps} from '@progress/kendo-react-grid';
import { GridColumnMenuFilter, GridColumnMenuProps } from '@progress/kendo-react-grid';
import { orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { Button } from '@progress/kendo-react-buttons';
import { PageContext } from './PageContext';
import { getAdHistory} from '../services/apiService';
import { subElement } from '../services/interfaces';
import { gSettings } from './Configuration';
import { filterIcon } from '@progress/kendo-svg-icons';

import { process, State, DataResult } from '@progress/kendo-data-query';

import { UserContext } from './UserContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEnvelope, faAddressCard, faInfoCircle, faQuestionCircle} from '@fortawesome/free-solid-svg-icons';
import { getter } from '@progress/kendo-react-common';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import parse from 'html-react-parser';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { DateTimePicker } from '@progress/kendo-react-dateinputs';
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';
import { longDateTime } from '../services/interfaces';

const initialDataState: State = {
    sort: [{ field: 'time', dir: 'desc' }],
};


const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
        <div>
            <GridColumnMenuFilter {...props} expanded={true} />
        </div>
    );
};

export function HistoryList (){
    const [history, setHistory] = useState<Array<subElement>>([]);
    
    const pageContext=useContext(PageContext);
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(history,dataState));

    const [locale, setLocale] = useState<string | undefined>(undefined);
    
    const getHistory=()=>{
        const element = pageContext?.selectedAd.element;
        const type = pageContext?.selectedAd.elementType;
        const elpath = pageContext?.selectedAd.path;
        if (element){
            getAdHistory(element).then(data=>{
                console.log(data);
                setHistory(data);
                setDataResult(process(data, dataState));
            });
        }
    }

    const onDataStateChange = (e: GridDataStateChangeEvent) => {
            setDataState(e.dataState);
            setDataResult(process(history, e.dataState));
        };
    
    const localeDate=(props:GridCustomCellProps)=>{
        console.log(props.dataItem);
        const longDtStr = (props.dataItem["time"]).toString();
        const longDateTime:longDateTime = {
            year:longDtStr.substring(0,4),
            month:longDtStr.substring(4,6),
            day:longDtStr.substring(6,8),
            hour:longDtStr.substring(8,10),
            minute:longDtStr.substring(10,12),
            second:longDtStr.substring(12,14),
        }
        //console.log(longDateTime);

        const newDateTime=new Date(longDateTime.month+"/"+longDateTime.day+"/"+longDateTime.year +" "+ longDateTime.hour + ":" + longDateTime.minute + ":" + longDateTime.second);
         return (
             <td {...props.tdProps}>
                {newDateTime.toLocaleDateString(locale) + " " + newDateTime.toLocaleTimeString(locale)}
             </td>
         )
    }

    useEffect(() => {
        getHistory()
        gSettings().then(settings => setLocale(settings.Locale));        
    }, []);
    return(
        <>        
        <Grid
            data={dataResult}

            dataItemKey='element'
            scrollable='scrollable'
            sortable={true}
            onDataStateChange={onDataStateChange}
            columnMenuIcon={filterIcon}
            {...dataState}
        >            
            <Column
                field="time"
                title="Time"
                cells={{data:localeDate}}
                width={200}
                columnMenu={ColumnMenu} 

            />
            <Column
                field='user_Name'
                title='User'
                columnMenu={ColumnMenu} 
            />
            <Column
                field='operation_Id'
                title='&nbsp;'
                width={80}
                columnMenu={ColumnMenu} 
            />
            <Column
                field='operation'
                title='Operation'
                columnMenu={ColumnMenu} 
            />
        </Grid>
        </>
    )
}